export default "__VITE_ASSET__Cu8eOwfW__"